import { render, staticRenderFns } from "./Qft.vue?vue&type=template&id=330e61cd&scoped=true"
import script from "./Qft.vue?vue&type=script&lang=js"
export * from "./Qft.vue?vue&type=script&lang=js"
import style0 from "./Qft.vue?vue&type=style&index=0&id=330e61cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330e61cd",
  null
  
)

export default component.exports